import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import Image from '../AppImage';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigationItems = [
    { name: 'Home', path: '/', icon: 'Home' },
    { name: 'Treatments', path: '/treatments', icon: 'Heart' },
    { name: 'About', path: '/about', icon: 'Users' },
    { name: 'Testimonials', path: '/testimonials', icon: 'MessageCircle' },
    { name: 'Contact', path: '/contact', icon: 'MapPin' }];


  const moreItems = [
    //{ name: 'Patient Portal', path: '/patient-portal', icon: 'User' },
    //{ name: 'Diet & Exercise', path: '/services', icon: 'Leaf' },
    //{ name: 'Panchakarma', path: '/panchakarma', icon: 'Droplets' }
  ];



  const isActivePath = (path) => location?.pathname === path;

  const handleNavigation = (path) => {
    window.location.href = path;
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ?
        'glass-panel shadow-glassmorphism' :
        'bg-transparent'}`
      }>

      <div className="max-w-7xl mx-auto">
        <div className="items-center justify-between h-16 px-4 lg:px-8 flex">
          {/* Logo */}
          <div
            className="flex items-center cursor-pointer morph-hover mr-6 lg:mr-8"
            onClick={() => handleNavigation('/')}>

            <div className="relative h-full py-4">
              <Image
                src="/assets/images/APK_LogoVector1-1765235042576.png"
                alt="Sri Dhanwantari AyurVaidik Parishkar Kendra - Authentic Ayurvedic Healing Center"
                className="h-full w-auto max-h-16 lg:max-h-16 object-contain opacity-100 mix-blend-darken dark:mix-blend-lighten brightness-100 contrast-60 mt-[2px]" />

            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems?.map((item) =>
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-300 morph-hover ${isActivePath(item?.path) ?
                  'bg-primary/10 text-primary shadow-subtle' :
                  'text-foreground hover:bg-muted hover:text-primary'}`
                }>

                <Icon name={item?.icon} size={18} className="mr-2" />
                {item?.name}
              </button>
            )}

            {/* More Dropdown */}
            {moreItems?.length > 0 && (
              <div className="relative group">
                <button className="flex items-center px-4 py-2 rounded-lg font-medium text-foreground hover:bg-muted hover:text-primary transition-all duration-300 morph-hover">
                  <Icon name="MoreHorizontal" size={18} className="mr-2" />
                  More
                  <Icon name="ChevronDown" size={16} className="ml-1 transition-transform group-hover:rotate-180" />
                </button>

                <div className="absolute top-full right-0 mt-2 w-48 glass-card opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                  {moreItems?.map((item) =>
                    <button
                      key={item?.path}
                      onClick={() => handleNavigation(item?.path)}
                      className={`flex items-center w-full px-4 py-3 text-left hover:bg-primary/5 transition-colors duration-200 first:rounded-t-lg last:rounded-b-lg ${isActivePath(item?.path) ? 'text-primary bg-primary/5' : 'text-foreground'}`
                      }>

                      <Icon name={item?.icon} size={16} className="mr-3" />
                      {item?.name}
                    </button>
                  )}
                </div>
              </div>)}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block ml-6">
            <Button
              variant="default"
              className="cta-morph ayurveda-gradient text-white font-cta font-semibold px-6 py-2.5"
              onClick={() => handleNavigation('/specialist-booking')}
              iconName="Calendar"
              iconPosition="left"
              iconSize={18}>

              Book Consultation
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden p-2 rounded-lg hover:bg-muted transition-colors duration-200 morph-hover">

            <Icon
              name={isMenuOpen ? "X" : "Menu"}
              size={24}
              className="text-foreground transition-transform duration-300" />

          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden transition-all duration-300 overflow-hidden ${isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'}`
        }>
          <div className="bg-white dark:bg-gray-900 mt-2 mx-4 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700">
            <nav className="py-4">
              {[...navigationItems, ...moreItems]?.map((item) =>
                <button
                  key={item?.path}
                  onClick={() => handleNavigation(item?.path)}
                  className={`flex items-center w-full px-6 py-3 text-left transition-colors duration-200 ${isActivePath(item?.path) ?
                    'text-primary bg-primary/10 border-r-4 border-primary font-semibold' : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-primary'}`
                  }>

                  <Icon name={item?.icon} size={20} className="mr-4" />
                  <span className="font-medium">{item?.name}</span>
                </button>
              )}

              <div className="px-6 pt-4 border-t border-gray-200 dark:border-gray-700 mt-4">
                <Button
                  variant="default"
                  fullWidth
                  className="cta-morph ayurveda-gradient text-white font-cta font-semibold"
                  onClick={() => handleNavigation('/specialist-booking')}
                  iconName="Calendar"
                  iconPosition="left"
                  iconSize={18}>

                  Book Consultation
                </Button>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>);

};

export default Header;